module.exports = __webpack_public_path__ + "img/DEFOR.b9a5367c.png";